import {gql} from 'apollo-angular';

export const INCREASE_JOB_MARKET_APPLICATION_COUNT = gql`
  mutation increaseJobMarketApplicationCount($jobMarketId: Int!) {
    increaseJobMarketApplicationCount(jobMarketID: $jobMarketId) {
      type
      message
    }
  }
`;
